import React, { useState, useEffect } from 'react';
import * as api from '../services/api';
import { Loader } from 'lucide-react';

const LighthouseDetail = ({ lighthouse, workerApiUrl }) => {
    const [pings, setPings] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPings = async () => {
            setIsLoading(true);
            try {
                const data = await api.getLighthousePings(workerApiUrl, lighthouse.id);
                setPings(data);
            } catch (err) {
                setError('Failed to fetch ping history.');
            } finally {
                setIsLoading(false);
            }
        };
        fetchPings();
    }, [lighthouse.id, workerApiUrl]);

    const StatusIndicator = ({ statusCode }) => {
        const isUp = statusCode >= 200 && statusCode < 300;
        return <div className={`status-indicator ${isUp ? 'up' : 'down'}`} title={`Status: ${statusCode}`}></div>;
    };

    return (
        <div className="lighthouse-detail">
            {isLoading && <Loader size={24} className="animate-spin" />}
            {error && <p className="error-message">{error}</p>}
            
            <div className="pings-list">
                {pings.map(ping => (
                    <div key={ping.id} className="ping-item">
                        <StatusIndicator statusCode={ping.status_code} />
                        <span className="ping-time">{new Date(ping.pinged_at).toLocaleString()}</span>
                        <span className="ping-duration">{ping.duration_ms}ms</span>
                        <span className="ping-status">{ping.status_code}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LighthouseDetail;
